export const IconTrophy = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M16.321 2H7.679a1.82 1.82 0 0 0-1.817 1.883q.01.311.027.617H1.815a.93.93 0 0 0-.926.938c0 3.617 1.292 6.132 3.028 7.84 1.71 1.683 3.793 2.53 5.328 2.96.903.254 1.52 1.016 1.52 1.782 0 .816-.655 1.48-1.462 1.48H8.296c-.683 0-1.234.559-1.234 1.25S7.613 22 8.296 22h7.408c.683 0 1.234-.559 1.234-1.25s-.551-1.25-1.234-1.25h-1.007a1.473 1.473 0 0 1-1.462-1.48c0-.766.613-1.532 1.52-1.782 1.539-.43 3.622-1.277 5.331-2.96 1.733-1.708 3.025-4.223 3.025-7.84a.93.93 0 0 0-.926-.938h-4.074c.012-.203.02-.406.027-.617A1.82 1.82 0 0 0 16.321 2M2.775 6.375h3.257c.35 3.52 1.126 5.871 2.002 7.445-.96-.43-1.96-1.035-2.824-1.886-1.235-1.215-2.238-2.97-2.43-5.559zm16.019 5.559c-.864.851-1.863 1.457-2.824 1.886.876-1.574 1.651-3.925 2.002-7.445h3.256c-.196 2.59-1.2 4.344-2.43 5.559z" />
    </svg>
  );
};
